// Structural receipt/ticket labels resolved by the restaurant language.
// Mirrors backend RECEIPT_LABELS (routers/receipts.py) so the Gestore preview,
// the browser fallback print and the silent agent all render identical wording.
export const RECEIPT_LABELS = {
  it: {
    subtotal: 'Subtotale', total: 'TOTALE', discount: 'Sconto', taxable: 'Imponibile',
    vat_included: 'IVA {rate}% inclusa', non_fiscal: 'DOCUMENTO NON FISCALE', table: 'Tavolo',
    covers: 'Coperti', operator: 'Operatore', waiter: 'Cameriere', qr_hint: 'Inquadra il QR per la copia PDF',
    description: 'Descrizione', qty: 'Q.tà', price: 'Prezzo', line_total: 'Totale',
    kitchen: 'CUCINA', bar: 'BAR', number: 'N.', vat_label: 'P.IVA', phone_label: 'Tel',
  },
  es: {
    subtotal: 'Subtotal', total: 'TOTAL', discount: 'Descuento', taxable: 'Base imponible',
    vat_included: 'IVA {rate}% incluido', non_fiscal: 'DOCUMENTO NO FISCAL', table: 'Mesa',
    covers: 'Comensales', operator: 'Operador', waiter: 'Camarero', qr_hint: 'Escanea el QR para la copia PDF',
    description: 'Descripción', qty: 'Cant.', price: 'Precio', line_total: 'Total',
    kitchen: 'COCINA', bar: 'BAR', number: 'N.', vat_label: 'CIF/NIF', phone_label: 'Tel',
  },
  en: {
    subtotal: 'Subtotal', total: 'TOTAL', discount: 'Discount', taxable: 'Taxable',
    vat_included: 'VAT {rate}% included', non_fiscal: 'NON-FISCAL DOCUMENT', table: 'Table',
    covers: 'Covers', operator: 'Operator', waiter: 'Waiter', qr_hint: 'Scan the QR for the PDF copy',
    description: 'Description', qty: 'Qty', price: 'Price', line_total: 'Total',
    kitchen: 'KITCHEN', bar: 'BAR', number: 'No.', vat_label: 'VAT', phone_label: 'Tel',
  },
  fr: {
    subtotal: 'Sous-total', total: 'TOTAL', discount: 'Remise', taxable: 'Base HT',
    vat_included: 'TVA {rate}% incluse', non_fiscal: 'DOCUMENT NON FISCAL', table: 'Table',
    covers: 'Couverts', operator: 'Opérateur', waiter: 'Serveur', qr_hint: 'Scannez le QR pour la copie PDF',
    description: 'Description', qty: 'Qté', price: 'Prix', line_total: 'Total',
    kitchen: 'CUISINE', bar: 'BAR', number: 'N°', vat_label: 'TVA', phone_label: 'Tel',
  },
  pt: {
    subtotal: 'Subtotal', total: 'TOTAL', discount: 'Desconto', taxable: 'Base tributável',
    vat_included: 'IVA {rate}% incluído', non_fiscal: 'DOCUMENTO NÃO FISCAL', table: 'Mesa',
    covers: 'Pessoas', operator: 'Operador', waiter: 'Empregado', qr_hint: 'Digitalize o QR para a cópia PDF',
    description: 'Descrição', qty: 'Qtd.', price: 'Preço', line_total: 'Total',
    kitchen: 'COZINHA', bar: 'BAR', number: 'N.º', vat_label: 'NIF', phone_label: 'Tel',
  },
};

export const receiptLabels = (lang) => RECEIPT_LABELS[(lang || 'it').toLowerCase()] || RECEIPT_LABELS.it;
